import { gql } from '@apollo/client';

const JOYRIDE_FIELDS = `
  id
  name
  startDate
  endDate
  challenge
  target
  challengeTeamUrl
  archivedAt
  isLive
`;

/** The campaign currently on display. This is what the iOS app reads. */
export const GET_JOYRIDE = gql`
query Joyride {
  joyride {
    ${JOYRIDE_FIELDS}
  }
}`;

/** Every campaign, live first — backs the history list on the leadership page. */
export const GET_JOYRIDES = gql`
query Joyrides {
  joyrides {
    ${JOYRIDE_FIELDS}
  }
}`;
